export class MenuModule {

	constructor() {
        this.$trigger = $("[data-menu-role='trigger']");
        this.$action = $("[data-menu-role='action']");
        this.$menuLinks = $('.main-nav-menu a');
        this.init();
	}

	init() {
        this.$trigger.on('click', (e) => this.handleMenuClick(e));
        this.$menuLinks.on('click', (e) => this.handleLinkClick(e));
	}

    handleMenuClick(e) {
        this.menuIsOpen() ? this.closeMenu() : this.openMenu();
    }

    handleLinkClick(e) {
        if ($(e.target).attr('href').indexOf('#') > -1) {
            this.closeMenu();
        }
    }

    menuIsOpen() {
        return this.$action.hasClass('active');
    }

    openMenu() {
        this.$action.addClass('active');
        this.$trigger.addClass('active');
    }

    closeMenu() {
        this.$action.removeClass('active');
        this.$trigger.removeClass('active');
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/sleeping-giants/assets/scripts/src/App/MenuModule.js